import api from '@/utils/api';
import LoadingComponent from '@/components/loading-component';
import * as Constants from '@/constants';
import ProviderAutocomplete from './add-new-provider-autocomplete.vue';

export default {
  name: 'StudentAdd',
  components: {
    LoadingComponent,
    ProviderAutocomplete
  },
  props: ['showTooltip'],
  data() {
    return {
      selectedStudent: null,
      selectedStudentCopy: null,
      // select student autocomplete
      studentSearchError: '',
      studentSearchInput: null,
      studentSearchLoading: false,
      studentsArray: [],
      // app loading screen
      showLoading: false,
      errorMsg: null,
      studentServices: null,
      studentsList: null,
      panel: [true],
      addNewProvider: false,
      newProvider: '',
      serviceId: null
    };
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    },
    isDesktop() {
      return this.$mq === 'laptop' || this.$mq === 'desktop';
    }
  },
  methods: {
    clearStudentAutoComplete() {
      if (!this.selectedStudent) {
        this.studentsArray = [];
      }
    },
    onRetrieveStudentDetailsClicked() {
      this.errorMsg = null;
      this.studentServices = null;
      this.showLoading = true;
      api.get(Constants.GET_STUDENT_SERVICE_LIST_BY_STUDENT_URL(this.selectedStudentCopy.studentId))
        .then((res) => {
          if (!res.data.data.length) throw new Error('Student does not have any eligible services.');
          this.showLoading = false;
          this.studentServices = res.data.data;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.errorMsg = error.response.data.message;
          } else {
            this.errorMsg = error.message;
          }
        })
        .finally(() => {
          this.selectedStudent = null;
          this.showLoading = false;
        });
    },
    updateStudentServices() {
      this.errorMsg = null;
      this.showLoading = true;
      api.get(Constants.GET_STUDENT_SERVICE_LIST_BY_STUDENT_URL(this.selectedStudentCopy.studentId))
        .then((res) => {
          if (res.data.status !== 'success') throw new Error('Something went wrong.')
          this.studentServices = res.data.data;
          this.showLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.errorMsg = error.response.data.message;
          } else {
            this.errorMsg = error.message;
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    }
  },
  watch: {
    // fires the api call to get student list
    studentSearchInput() {
      // show loading
      this.studentSearchLoading = true;
      // clear timeout if function is called before setTimeout fires
      clearTimeout(this.timeout);
      // make sure the user types something before firing request
      if (this.studentSearchInput) {
        // fire the request after a delay
        this.timeout = setTimeout(() => {
          api.get(Constants.GET_SCHEDULER_STUDENT_LIST_URL(this.studentSearchInput))
            .then((res) => {
              this.studentsArray = res.data.data;
            })
            .catch((error) => {
              this.studentSearchError = error.message;
            })
            .finally(() => {
              this.studentSearchLoading = false;
            });
        }, 300);
      } else {
        this.studentSearchLoading = false;
      }
    },
    // watcher on selectedStudent to clear the value when clicking on the X
    selectedStudent(newVal, oldVal) {
      if (newVal) this.selectedStudentCopy = newVal;
      if (!newVal && oldVal) this.studentsArray = [];
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/agency-scheduler/add-by-student/add-by-student.js